import { useCallback, useEffect } from "react";
var listenerHandler = function(fn, match, data) {
    if (typeof match === "string" ? match === data : match.test(data)) {
        fn(data);
    }
};
/**
  Function _for React DOM_ to send a message from the web to the app.

  @param message
    The message to be sent from the web (React DOM) to React Native.
 */ export var sendMessageToApp = function(message) {
    var _window_ReactNativeWebView;
    if (typeof (window === null || window === void 0 ? void 0 : (_window_ReactNativeWebView = window.ReactNativeWebView) === null || _window_ReactNativeWebView === void 0 ? void 0 : _window_ReactNativeWebView.postMessage) === "function") {
        window.ReactNativeWebView.postMessage(message);
    }
};
/**
  Function _for React Native_ to send a message from the app to the web.

  @param message
    The message to be sent from React Native to the web (React DOM).
  @param webviewRef
    `<WebView>` `ref` object created by the `useRef` hook.
 */ export var sendMessageToWeb = function(message, webviewRef) {
    var _webviewRef_current;
    if (typeof (webviewRef === null || webviewRef === void 0 ? void 0 : (_webviewRef_current = webviewRef.current) === null || _webviewRef_current === void 0 ? void 0 : _webviewRef_current.postMessage) === "function") {
        webviewRef.current.postMessage(message);
    }
};
/**
  Hook _for React DOM_ to listen for messages sent from the app to the web.

  @param fn
    The listener function to be executed when a matching message is received.
  @param match
    The string or regular expression used to match the message content.
 */ export var useListenToApp = function(fn) {
    var match = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /.*/;
    var handleMessage = useCallback(function(param) {
        var data = param.data;
        return listenerHandler(fn, match, data);
    }, [
        fn,
        match
    ]);
    useEffect(function() {
        if (typeof (window === null || window === void 0 ? void 0 : window.addEventListener) === "function") {
            window.addEventListener("message", handleMessage);
            return function() {
                return window.removeEventListener("message", handleMessage);
            };
        }
    }, [
        handleMessage
    ]);
};
/**
  Hook _for React Native_ to listen for messages sent from the web to the app.

  @param fn
    The listener function to be executed when a matching message is received.
  @param match
    The string or regular expression used to match the message content.
  @returns
    Returns a function to use with `<WebView>` `onMessage` prop.
 */ export var useListenToWeb = function(fn) {
    var match = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /.*/;
    return function(param) {
        var data = param.nativeEvent.data;
        return listenerHandler(fn, match, data);
    };
};
